
























































































































import {Component, Vue} from 'vue-property-decorator';
import {Stored} from 'vue-stored-prop-decorator';
import {Player, Game, GameMode} from '@/models';
import playerStore from '@/stores/modules/player';
import gameStore from '@/stores/modules/game';
import saver from "@/Saver";
import manager from "../Manager/Manager";

@Component({
	components: {
	},
})
export default class Create extends Vue {
	
	@Stored(playerStore)
	public players: Player[];
	
	@Stored(gameStore)
	public game: Game;
	
	public submited: boolean = false;
	
	public GameMode = GameMode;
	
	public clearPlayerConfirm: boolean = false;
	
	public addPlayer(): void {
		playerStore.commit('addPlayer', new Player());
	}
	
	public removePlayer(player: Player): void {
		playerStore.commit('removePlayer', player);
	}
	
	public get doubletteValid(): boolean {
		return this.game.mode !== GameMode.DOUBLETTE || ( this.players.length >= 4 && this.players.length % 2 === 0);
	}
	
	public get tripletteValid(): boolean {
		return this.game.mode !== GameMode.TRIPLETTE || (this.players.length >= 6 && this.players.length % 3 === 0);
	}
	
	public get more8TAT(): boolean {
		return this.game.mode === GameMode.TETE_A_TETE && this.players.length > 8;
	}
	
	public get more10Doublette(): boolean {
		return this.game.mode === GameMode.DOUBLETTE && this.players.length > 10;
	}
	
	public submit(): void {
		this.submited = true;
		if (
			!this.players.filter(p => !p.name).length &&
			this.doubletteValid &&
			this.tripletteValid &&
			!this.more8TAT &&
			!this.more10Doublette
		) {
			this.game.createMatch();
			this.game.started = true;
			this.save();
			this.$router.push({ name: 'start' });
		}
	}
	
	private save() {
		saver.saveCurrent();
	}
	
	public clearPlayer(): void {
		this.players.forEach(p => manager.unregister(p));
		playerStore.commit('reset');
		this.save();
		this.clearPlayerConfirm = false;
	}
	
}

